export default {
  // Hero
  hero_title: "CATÁLOGO DE EQUIPOS PARA CONSTRUCCIÓN VERTICAL",
  hero_view_products: "Ver Productos",
  hero_request_quote: "Solicitar Presupuesto",

  // Products Section
  products_title: "Equipos de Alto Rendimiento",
  product1_name: "Elevador de Obra con Cremallera",
  product2_name: "Grúa Trepadora con Sistema de Elevación",

  // Specifications
  spec_work_height: "Altura de Trabajo",
  spec_load_capacity: "Capacidad de Carga",
  spec_speed: "Velocidad",
  spec_configuration: "Configuración",
  spec_total_area: "Área Interna Total",
  spec_floor_area: "Área del Piso",
  spec_volume: "Volumen Aproximado",
  spec_tower_height: "Altura de la Torre",
  spec_service_height: "Altura de Servicio",
  spec_max_capacity: "Capacidad Máxima",
  spec_steel_cables: "Cables de Acero",

  // Product Details
  product1_safety_title: "Características de Seguridad",
  product1_safety_desc: "Sistema sin puerta",
  product2_accessories_title: "Accesorios Incluidos",
  product2_accessories_desc: "Horquilla para cargas hasta 2.000 kg + Cubo para hormigón",

  // Video Section
  video_title: "Vea los Equipos en Operación",

  // Conditions
  conditions_delivery_title: 'Condiciones de Entrega y Pago',
  conditions_delivery_subtitle: 'Información sobre plazos y logística',
  conditions_shipping_title: 'Previsión de Envío',
  conditions_shipping_desc: '30 días después de la confirmación del pedido',
  conditions_delivery_card_title: 'Entrega',
  conditions_delivery_desc: '60 días después del envío (puerto de destino)',
  conditions_packaging_title: 'Embalaje',
  conditions_packaging_desc: 'Caja de madera',
  conditions_warranty_title: 'Garantía',
  conditions_warranty_period: '1 año proporcionada por el fabricante',
  conditions_manufacturer_title: 'Fabricante',

  // Contact
  contact_title: "Póngase en Contacto",
  contact_schedule_title: "Programar una Reunión",
  contact_schedule_desc: "Hable con nuestro equipo a través de Microsoft Teams",
  contact_email_title: "Contáctenos",
  contact_email_desc: "Envíe un correo electrónico a nuestro equipo comercial",

  // Footer
  footer_description: "Equipos importados para construcción vertical",
  footer_products: "Productos",
  footer_product1: "Elevador de Obra",
  footer_product2: "Grúa Trepadora",
  footer_info: "Información",
  footer_about: "Sobre Nosotros",
  footer_warranty: "Garantía",
  footer_delivery: "Entrega",
  footer_contact: "Contacto",
  footer_address: "R. Voluntários da Pátria, nº 2468 / 2490, 6º piso",
  footer_building: "Edificio Brasília Corporate",
  footer_hours: "Lunes a viernes, 08:30 a 18:00 (GMT -03:00)",
  footer_rights: "© 2026 Moviis. Todos los derechos reservados.",

  // Language Switcher
  language_select: "Seleccionar idioma",

  share: {
    whatsappMessage: '¡Hola! Aquí está el catálogo de equipos para construcción vertical Moviis:',
    emailSubject: 'Catálogo Moviis — Equipos para Construcción Vertical',
    emailBody: '¡Hola! Aquí está el catálogo de equipos para construcción vertical Moviis:',
    whatsappTooltip: 'Compartir en WhatsApp',
    emailTooltip: 'Compartir por Email',
  },

  // Financial Summary
  financial_title: 'Resumen Financiero',
  financial_subtitle: 'Valores y condiciones de pago',
  financial_total_label: 'Total del Pedido',
  financial_total_value: 'A consultar',
  financial_installment1_label: 'Cuota 1',
  financial_installment1_desc: '30% para iniciar producción',
  financial_installment1_value: 'A consultar',
  financial_installment2_label: 'Cuota 2',
  financial_installment2_desc: 'Pago del producto para liberación de envío',
  financial_installment2_value: 'A consultar',
  financial_installment3_label: 'Cuota 3 (Saldo)',
  financial_installment3_desc: 'Llegada al destino (puerto o aeropuerto)',
  financial_installment3_value: 'A consultar',
  financial_invoice_date: 'Fecha: 4 de febrero de 2026',
  financial_considerations_title: 'Consideraciones de la Propuesta',
  financial_considerations_subtitle: 'Términos y condiciones importantes',
  financial_validity_label: 'Validez de la propuesta:',
  financial_validity: '15 días',
  financial_shipping_label: 'Plazo de envío:',
  financial_shipping: 'Los equipos deben enviarse dentro de 3 meses. Después de este período, el contrato se considerará inválido.',
  financial_observation_label: 'Observación:',
  financial_observation: 'Al tratarse de la importación directa de 10 equipos, cualquier sustitución o inclusión de nuevos artículos implicará un recálculo de los valores.',
  financial_assembly_label: 'Montaje y mantenimiento técnico:',
  financial_assembly: 'No incluidos (responsabilidad del comprador).',
  financial_btn_print: 'Imprimir',
  financial_btn_pdf: 'Descargar PDF',
  financial_btn_whatsapp: 'Enviar por WhatsApp',
  financial_btn_email: 'Enviar por correo',
};